export const breakpointNames = ['xs', 'sm', 'md', 'lg', 'xl'] as const;
export type Breakpoint = (typeof breakpointNames)[number];

export function isBreakpoint(value: any): value is Breakpoint {
  return typeof value === 'string' && (breakpointNames as readonly any[]).includes(value);
}

export const breakpoints: { [_ in Breakpoint]: string | number } = {
  xs: 'var(--break-xs)',
  sm: 'var(--break-sm)',
  md: 'var(--break-md)',
  lg: 'var(--break-lg)',
  xl: 'var(--break-xl)',
} as const;

export function getWidth(value: any) {
  if (isBreakpoint(value)) return breakpoints[value];
  return value;
}
